import { Button, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import LogoSVG from 'src/assets/images/logo_report_blue_katakana.svg?react'

const Error404: React.FC = () => {
  return (
    <Stack
      height="100vh"
      alignItems="center"
      justifyContent="center"
      gap={4}
      p={2}
      sx={{ mx: 'auto' }}
    >
      <LogoSVG width={287} height={40} />
      <Typography variant="subtitle1">ページが見つかりませんでした</Typography>
      <Typography variant="body1">
        ページが削除されたか、URLが変更になっている可能性があります。
      </Typography>
      <Link to={'/'}>
        <Button variant="contained" color="primary">
          トップページへ戻る
        </Button>
      </Link>
    </Stack>
  )
}

export default Error404
